<template>
  <div class="module">
    <div class="box f--c">
      <div class="title1">{{ $t('Customize.Module8.Title1') }}</div>
      <div class="sub1">{{ $t('Customize.Module8.Sub1') }}</div>
      <a v-if="userId" href="/mall"><el-button class="btn">{{ $t('Customize.Module8.Btn') }}</el-button></a>
      <a v-else href="/register"><el-button class="btn">{{ $t('Customize.Module8.Btn1') }}</el-button></a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  }
}
</script>

<style lang="scss" scoped>
.module {
  padding: 104px 0;
  background-image: url('https://img.kakaclo.com/web-img/home/pod/bg_img4.png?x-oss-process=image/resize,w_1280,h_281,m_fill/format,webp');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .box {
    flex-direction: column;
  }
  .title1 {
    color: #fff;
    font-size: 48px;
    line-height: 68px;
    margin-bottom: 16px;
    font-weight: bold;
  }
  .sub1 {
    color: #fff;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 48px;
  }
  .btn {
    height: 56px;
    background: linear-gradient(90deg, #E7E140 0%, #9AC331 100%);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }
}
@media screen and (max-width: 1000px) {
  .module {
    padding: 48px 0;
    .box {
      .title1 {
        font-size: 22px;
        line-height: 30px;
        margin-bottom: 12px;
      }
      .sub1 {
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 20px;
      }
      .btn {
        height: 40px;
        font-size: 16px;
      }
    }
  }
}
</style>
